/**
 *
 * @param time in `milisecods`
 */
export const delay = async (time = 500) =>
  await new Promise(r => setTimeout(r, time));
